import {
  PAGESIZE_UPDATED,
  PAGE_SELECTED,
  ASSETS_FAILED_TO_POPULATE,
  ASSETS_SELECTED,
  ASSET_VIEWED
} from './assets.action';

// GTM-UPDATE
const addToDataLayer = data => window.dataLayer.push(data);


const assetViewed = action => ({
  hitType: 'event',
  eventCategory: 'asset-search',
  eventAction: 'asset-Viewed',
  eventLabel: action.payload.id
});

// const assetsPageSelected = action => ({
//   hitType: 'event',
//   eventCategory: 'asset-search',
//   eventAction: 'asset-page-selected',
//   eventLabel: action.payload
// });

const assetsPageSizeUpdated = action => ({
  hitType: 'event',
  eventCategory: 'asset-search',
  eventAction: 'assets-page-size-updated',
  eventLabel: action.payload
});

const assetsFailedToPopulate = action => ({
  hitType: 'event',
  eventCategory: 'asset-search',
  eventAction: 'assets-failed-to-populate',
  eventLabel: action.payload
});

// const assetsSelected = () => ({
//   hitType: 'event',
//   eventCategory: 'asset-search',
//   eventAction: 'assets-selected'
// });

export const AssetsAnalytics = {
  [PAGESIZE_UPDATED]: assetsPageSizeUpdated,
  [ASSET_VIEWED]: assetViewed,
  // [PAGE_SELECTED]: assetsPageSelected,
  [PAGE_SELECTED]: action => addToDataLayer({
    event: 'assetsPaging',
    data: action.payload
  }),
  [ASSETS_FAILED_TO_POPULATE]: assetsFailedToPopulate,
  // [ASSETS_SELECTED]: assetsSelected,
  [ASSETS_SELECTED]: action => addToDataLayer({
    event: 'assetsSelected',
    data: action.payload.map((selected) => { return { name: selected.name, id: selected.id } })
  }),
};
